document.addEventListener("DOMContentLoaded", function () {
  let st_searchIcon = document.querySelectorAll(".st-search-icon");
  let st_searchCrossIcon = document.querySelectorAll(".st-searchbox-close-btn");
  let st_searchBoxDesktop = document.querySelector(
    ".st-search-box.hidden-mobile"
  );
  let st_searchBoxMobile = document.querySelector(
    ".st-search-box.hidden-desktop"
  );

  function toggleStSearchBar(showSearchBar) {
    if (!isDeviceMobile()) {
      if (st_searchBoxDesktop)
        st_searchBoxDesktop.style.display = showSearchBar ? "" : "none";
      if (st_searchBoxMobile)
        st_searchBoxMobile.style.display = showSearchBar ? "" : "none";
      if (st_searchIcon) {
        st_searchIcon.forEach((x) => {
          x.style.display = showSearchBar ? "none" : "";
        });
      }
      if (st_searchCrossIcon) {
        st_searchCrossIcon.forEach((x) => {
          x.style.display = showSearchBar ? "" : "none";
        });
      }
    }
    st_searchIcon.forEach((a) => {
      setTimeout(() => {
        document.querySelectorAll('input[name="q"]').forEach((x) => {
          x.focus();
        });
      }, 100);
    });
  }

  if (st_searchIcon) {
    st_searchIcon.forEach((a) => {
      a.addEventListener("click", (e) => {
        setTimeout(() => {
          toggleStSearchBar(true);
        }, 300);
      });
    });
  }
  if (st_searchCrossIcon) {
    st_searchCrossIcon.forEach((a) => {
      a.addEventListener("click", (e) => {
        toggleStSearchBar(false);
      });
    });
  }

  function isDeviceMobile() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
  }

  setTimeout(() => {
    let st_clientsSearchIcon = document.querySelectorAll("li.search_link");
    console.log(st_clientsSearchIcon);
    if (st_clientsSearchIcon)
      st_clientsSearchIcon.forEach((x) => {
        x.addEventListener("click", (e) => {
          let rootElement = document.documentElement;
          rootElement.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          setTimeout(() => {
            toggleStSearchBar(true);
          }, 300);
        });
      });
  }, 300);
});
window.addEventListener("DOMContentLoaded", () => {
  let searchInputBox =
    document.documentElement.clientWidth >= 1025
      ? document.querySelector(".st-search-box #st-search")
      : document.querySelector(".st-search-box #st-search-mobile");

  const placeHolderPhrases = ["Search For Kurtas", "Search For Dresses", "Search for Sarees"];
  let index = 0;
  let typingTimer;
  const updatePlaceHolder = function () {
    const phrase = placeHolderPhrases[index];
    const length = phrase.length;
    let queryIndex = 0;
    typingTimer = setInterval(function () {
      if (queryIndex === length) {
        setTimeout(erasePlaceHolder, 1000);

        clearInterval(typingTimer);
      } else {
        const currentPlaceholderValue =
          searchInputBox.getAttribute("placeholder");

        searchInputBox.setAttribute(
          "placeholder",
          currentPlaceholderValue + phrase.charAt(queryIndex)
        );

        queryIndex++;
      }
    }, 100);
  };

  const erasePlaceHolder = function () {
    const currentPlaceholderValue = searchInputBox.getAttribute("placeholder");
    const length = currentPlaceholderValue.length;
    let queryIndex = length - 1;
    typingTimer = setInterval(function () {
      if (queryIndex === -1) {
        clearInterval(typingTimer);
        index++;
        if (index === placeHolderPhrases.length) {
          index = 0;
        }
        setTimeout(updatePlaceHolder, 1000);
      } else {
        const newPlaceholderValue = currentPlaceholderValue.slice(
          0,
          queryIndex
        );
        searchInputBox.setAttribute("placeholder", newPlaceholderValue);
        queryIndex--;
      }
    }, 50);
  };
  updatePlaceHolder();
});